import React from 'react';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import { FormControl, FormLabel } from '@mui/joy';

const FlatpickrDateTimeField = ({ label, value, onChange, disabled }) => {
  return (
    <FormControl>
      {label && <FormLabel>{label}</FormLabel>}
      <Flatpickr
        value={value ? new Date(value) : null}
        onChange={dateArr => onChange(dateArr[0] ? dateArr[0].toISOString().slice(0, 16) : '')}
        options={{
          enableTime: true,
          dateFormat: 'Y-m-d H:i',
          time_24hr: true,
          allowInput: true,
        }}
        disabled={disabled}
        style={{ width: '100%' }}
      />
    </FormControl>
  );
};

export default FlatpickrDateTimeField;
